import { Button, Dialog, DialogTitle, Grid, Stack } from '@mui/material';
import { mapCommunicationsToNotesDisplay } from './common-utils';
import { useState } from 'react';
import NoteAddForm from './NoteAddForm';
import { TABLE_HEAD_NOTES } from './table-head';
import { useCommunications } from 'src/careflow/ph-core/fhir-client/fhir-react';
import { TableCustom } from 'src/components/TableCustom';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { WrappedCarePlan } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/CarePlan';
import { CommunicationWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Communication';
import { translateTableHead } from '../helpers/common';
import { Add } from '@mui/icons-material';
import { i18nFunction } from 'src/careflow/ph-core/internationalization/hook/useLocales';

type ModalProps = {
  open: boolean;
  patient: WrappedPatient | null;
  resource: any;
  carePlan?: WrappedCarePlan | null;
  typeNote: string;
  onCancel: VoidFunction;
  isAllowedToAdd: boolean;
  i18n: i18nFunction;
};

export default function ModalCommunication({
  open,
  patient,
  resource,
  carePlan,
  typeNote,
  onCancel,
  isAllowedToAdd,
  i18n
}: ModalProps) {
  const [openNote, setOpenNote] = useState(false);

  const [communications, { refresh: refreshCommunications, create: createCommunication }] =
    useCommunications({
      filter: { 'part-of': resource?.id },
      map: CommunicationWrapper,
    });

  const handleCreateCommunicationFhir = async (data: any) => {
    let result: any = {};

    try {
      result = await createCommunication(data);

      setOpenNote(false);
      refreshCommunications();
    } catch (err) {
      console.log('error on handleCreateCommunicationFhir', err);
    }

    return result;
  };

  return (
    <>
      <Dialog open={open} onClose={onCancel} fullWidth={true} maxWidth="md">
        <TableCustom
          data={mapCommunicationsToNotesDisplay(communications, [typeNote])}
          tableHead={translateTableHead(TABLE_HEAD_NOTES, i18n, 'crs')}
          childrenButtons={
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ my: 1, pl: 2 }}
            >
              <DialogTitle sx={{ m: 0, p: 0 }}>Notes</DialogTitle>

              {isAllowedToAdd && (
                <Button
                  size="small"
                  variant="contained"
                  sx={{ height: '36px' }}
                  startIcon={<Add />}
                  onClick={() => setOpenNote(true)}
                >
                  Add A Note
                </Button>
              )}
            </Grid>
          }
        />
      </Dialog>
      <NoteAddForm
        open={openNote}
        patient={patient}
        onCancel={() => setOpenNote(false)}
        resource={[resource, carePlan]}
        handleCreate={handleCreateCommunicationFhir}
        typeNote={typeNote}
      />
    </>
  );
}
